<h1 id="timepicker-title" class="sr-only">{{ 'a11y.page_title.timepicker' | translate }}</h1>
<div class="position-relative">
<ion-datetime [(ngModel)]="time" presentation="time" locale="en-US"></ion-datetime>
<span>:</span>
</div>
<div class="bottom-actions">
    <ion-button  expand="block" fill="clear" (click)="cancel()">{{ 'common.cancel' | translate }}</ion-button>
    |
    <ion-button  expand="block" fill="clear" (click)="close()">Set</ion-button>
</div>